import { Route } from 'vue-router';
import { DEVICE } from '@/define/Adapter';
import { mobileUtil } from '@panda/tool';

const queryGeek = () => (mobileUtil.isGeekApp() ? { needlogin: true, portrait: true } : {});
const QUERY = queryGeek();

export default [
  {
    path: '/market',
    name: 'Market',
    component: () => import(/* webpackChunkName: "market" */ '../views/market/Index.vue'),
    children: [
      {
        path: '/market/activity/:id',
        name: 'Market.Activity',
        component: () => import(/* webpackChunkName: "market.activity" */ '../views/market/Activity.vue'),
        props: (route: Route) => ({
          id: Number(route.params.id),
          // eslint-disable-next-line no-underscore-dangle
          traceName: route.query._trace_name,
        }),
        meta: {
          title: '运营活动',
        },
      },
      {
        path: '/market/goods/gather',
        name: 'Market.GoodsGather',
        component: () => import(/* webpackChunkName: "market.goods.gather" */ '../views/market/GoodsGather.vue'),
        meta: {
          title: 'vip会员，5大王牌内容畅学',
        },
        props: (route: Route) => ({
          tab: route.query.tab,
          courseId: route.query.courseId,
        }),
      },
      {
        path: '/market/goods/:id',
        name: 'Market.GoodsActivity',
        component: () => import(/* webpackChunkName: "market.goods.activity" */ '../views/market/GoodsActivity.vue'),
        props: (route: Route) => ({
          id: Number(route.params.id),
          courseId: route.query.courseId,
          // eslint-disable-next-line no-underscore-dangle
          traceName: route.query._trace_name,
        }),
        meta: {
          title: '商品活动',
        },
      },
      {
        path: '/market/invitation',
        name: 'Market.Invitation',
        component: () => import(/* webpackChunkName: "market.invitation" */ '../views/market/Invitation.vue'),
        children: [
          {
            path: '/market/invitation/activity',
            name: 'Market.Invitation.Activity',
            component: () => import(/* webpackChunkName: "market.invitation.activity" */ '../views/market/InvitationActivity.vue'),
            meta: {
              title: '邀请得VIP',
              needLogin: true,
            },
          },
          {
            path: '/market/invitation/poster',
            name: 'Market.Invitation.Poster',
            component: () => import(/* webpackChunkName: "market.invitation.posterShare" */ '../views/market/InvitationPosterShare.vue'),
            meta: {
              title: '邀请得VIP',
            },
            props: (route: Route) => ({
              inviteCode: route.query.inviteCode,
            }),
          },
          {
            path: '/market/invitation/download',
            name: 'Market.Invitation.Download',
            component: () => import(/* webpackChunkName: "market.invitation.download" */ '../views/market/InvitationDownload.vue'),
            meta: {
              title: '下载APP领会员',
              needLogin: true,
            },
            props: (route: Route) => ({
              isNew: route.query.isNew === 'true',
            }),
          },
        ],
      },
      {
        path: '/market/freeMember',
        name: 'Market.FreeMember',
        meta: {
          adapterRules: [{ device: DEVICE.Mobile }, { device: DEVICE.PC }],
        },
        component: () => import(/* webpackChunkName: "market.freeMember" */ '../views/market/FreeMemberIndex.vue'),
        children: [
          {
            path: '/market/freeMember/mobile',
            name: `Market.FreeMember.${DEVICE.Mobile}`,
            component: () => import(/* webpackChunkName: "market.freeMember.mobile" */ '../views/market/FreeMemberMobile.vue'),
            meta: {
              title: '网易有道素质课免费学',
            },
          },
          {
            path: '/market/freeMember/pc',
            name: `Market.FreeMember.${DEVICE.PC}`,
            component: () => import(/* webpackChunkName: "market.freeMember.pc" */ '../views/market/FreeMemberPC.vue'),
            meta: {
              title: '网易有道素质课免费学',
            },
          },
        ],
      },
      {
        path: '/market/supplyCertInfo',
        name: 'Market.SupplyCertInfo',
        component: () => import(/* webpackChunkName: "market.supplyCertInfo" */ '../views/market/SupplyCertInfo.vue'),
        meta: {
          title: '网易有道素质课免费学',
        },
      },
      {
        path: '/market/freeLunch',
        name: 'Market.FreeLunch',
        component: () => import(/* webpackChunkName: "market.supplyCertInfo" */ '../views/market/FreeLunch.vue'),
        meta: {
          title: '邀请好友一起学，助力免费午餐',
        },
      },
      {
        path: '/market/clockIn',
        name: 'Market.clockIn',
        component: () => import(/* webpackChunkName: "market.clockIn" */ '../views/market/ClockIn.vue'),
        meta: {
          title: '有道卡搭会员0元学',
          query: QUERY,
        },
      },
      {
        path: '/market/clockInExchange',
        name: 'Market.clockInExchange',
        component: () => import(/* webpackChunkName: "market.clockIn.exchange" */ '../views/market/ClockInExchange.vue'),
        meta: {
          title: '兑换进阶课',
          query: QUERY,
        },
        props: (route: Route) => ({
          goodsId: Number(route.query.goodsId),
        }),
      },
      {
        path: '/market/clockInCashback',
        name: 'Market.clockInCashback',
        component: () => import(/* webpackChunkName: "market.clockIn.cashback" */ '../views/market/ClockInCashback.vue'),
        meta: {
          title: '申请学费全返',
          query: QUERY,
        },
      },
      {
        path: '/market/freevip',
        name: 'Market.Freevip',
        component: () => import(/* webpackChunkName: "market.freevip" */ '../views/market/Freevip.vue'),
        meta: {
          title: '免费领取会员',
        },
      },
      {
        path: '/market/lottery',
        name: 'Market.Lottery',
        component: () => import(/* webpackChunkName: "market.lottery" */ '../views/market/Lottery.vue'),
        meta: {
          title: '幸运摇奖机',
        },
      },
      {
        path: '/market/lotteryRecords',
        name: 'Market.LotteryRecords',
        component: () => import(/* webpackChunkName: "market.lotteryRecords" */ '../views/market/LotteryRecords.vue'),
        meta: {
          title: '中奖记录',
        },
      },
      {
        path: '/market/clockInFc',
        name: 'Market.ClockInFc',
        component: () => import(/* webpackChunkName: "market.clockInForCourse" */ '../views/market/ClockInForCourse.vue'),
        meta: {
          title: '按时学习打卡兑换进阶课',
          query: QUERY,
        },
        props: () => ({
          clockInVersion: 1,
        }),
      },
      {
        path: '/market/clockInExchangeFc',
        name: 'Market.ClockInExchangeFc',
        component: () => import(/* webpackChunkName: "market.clockIn.exchangeForCourse" */ '../views/market/ClockInExchangeForCourse.vue'),
        meta: {
          title: '兑换进阶课',
          query: QUERY,
        },
        props: (route: Route) => ({
          goodsId: Number(route.query.goodsId),
          clockInVersion: 1,
        }),
      },
      {
        path: '/market/clockInFd', // 打卡-会员0元学
        name: 'Market.ClockInFd',
        component: () => import(/* webpackChunkName: "market.clockInForD" */ '../views/market/ClockInForD.vue'),
        meta: {
          title: '有道卡搭会员0元学',
          query: QUERY,
        },
        props: () => ({
          clockInVersion: 3,
        }),
      },
      {
        path: '/market/clockInExchangeFd', // 打卡-会员0元学
        name: 'Market.ClockInExchangeFd',
        component: () => import(/* webpackChunkName: "market.clockIn.exchangeForCourse" */ '../views/market/ClockInExchangeForCourse.vue'),
        meta: {
          title: '兑换进阶课',
          query: QUERY,
        },
        props: (route: Route) => ({
          goodsId: Number(route.query.goodsId),
          clockInVersion: 3,
        }),
      },
      {
        path: '/market/clockInCashbackFd', // 打卡-会员0元学
        name: 'Market.ClockInCashbackFd',
        component: () => import(/* webpackChunkName: "market.clockIn.cashbackFd" */ '../views/market/ClockInCashbackForD.vue'),
        meta: {
          title: '申请学费全返',
          query: QUERY,
        },
        props: () => ({
          clockInVersion: 3,
        }),
      },
      {
        path: '/market/clockInFe', // 打卡-写字0元学
        name: 'Market.ClockInFe',
        component: () => import(/* webpackChunkName: "market.clockInForE" */ '../views/market/ClockInForE.vue'),
        meta: {
          title: '按时学习练字学费全返',
          query: QUERY,
        },
        props: () => ({
          clockInVersion: 2,
        }),
      },
      {
        path: '/market/clockInExchangeFe', // 打卡-写字0元学
        name: 'Market.ClockInExchangeFe',
        component: () => import(/* webpackChunkName: "market.clockIn.exchangeForCourse" */ '../views/market/ClockInExchangeForCourse.vue'),
        meta: {
          title: '兑换课程',
          query: QUERY,
        },
        props: (route: Route) => ({
          goodsId: Number(route.query.goodsId),
          clockInVersion: 2,
          btnTitle: '兑换课程',
          groupTitle: '课程兑换成功',
        }),
      },
      {
        path: '/market/clockInCashbackFe', // 打卡-写字0元学
        name: 'Market.ClockInCashbackFe',
        component: () => import(/* webpackChunkName: "market.clockIn.cashbackFd" */ '../views/market/ClockInCashbackForD.vue'),
        meta: {
          title: '申请学费全返',
          query: QUERY,
        },
        props: () => ({
          clockInVersion: 2,
        }),
      },
      {
        path: '/market/clockInFf', // 编程打卡
        name: 'Market.ClockInFf',
        component: () => import(/* webpackChunkName: "market.clockInForF" */ '../views/market/ClockInForF.vue'),
        meta: {
          title: '按时学习编程学费全返',
          query: QUERY,
        },
        props: () => ({
          clockInVersion: 4,
        }),
      },
      {
        path: '/market/clockInExchangeFf', // 编程打卡 - 兑换
        name: 'Market.ClockInExchangeFf',
        component: () => import(/* webpackChunkName: "market.clockIn.exchangeForCourse" */ '../views/market/ClockInExchangeForCourse.vue'),
        meta: {
          title: '兑换课程',
          query: QUERY,
        },
        props: (route: Route) => ({
          goodsId: Number(route.query.goodsId),
          clockInVersion: 4,
          btnTitle: '兑换课程',
          groupTitle: '礼包兑换成功',
          groupSubtitle: '请在「已购内容」中查看课程',
        }),
      },
      {
        path: '/market/clockInCashbackFf', // 编程打卡 - 返现
        name: 'Market.ClockInCashbackFf',
        component: () => import(/* webpackChunkName: "market.clockIn.cashbackFd" */ '../views/market/ClockInCashbackForD.vue'),
        meta: {
          title: '申请学费全返',
          query: QUERY,
        },
        props: () => ({
          clockInVersion: 4,
        }),
      },
      {
        path: '/market/codeContest',
        name: 'Market.CodeContest',
        component: () => import(/* webpackChunkName: "market.supplyCertInfo" */ '../views/market/CodeContest.vue'),
        meta: {
          title: '编程作品大赛',
        },
        props: (route: Route) => ({
          goodsId: Number(route.query.goodsId),
        }),
      },
      {
        path: '/market/clockInLifeMember', // 畅学会员打卡
        name: 'Market.ClockInLifeMember',
        component: () => import(/* webpackChunkName: "market.clockIn.lifeMember" */ '../views/market/ClockInLifeMember.vue'),
        meta: {
          title: '有道卡搭畅学会员打卡',
          query: QUERY,
        },
      },
      {
        path: '/market/order/success',
        name: 'Market.OrderSuccess',
        component: () => import(/* webpackChunkName: "market.order.success" */ '../views/market/OrderSuccess.vue'),
        props: (route: Route) => ({
          uid: Number(route.query.uid),
          orderId: route.query.orderId,
        }),
        meta: {
          title: '交易成功',
        },
      },
      {
        path: '/market/zh/order/success',
        name: 'Market.OrderSuccessZongHeng',
        component: () => import(/* webpackChunkName: "market.order.success.zh" */ '../views/market/OrderSuccessZH.vue'),
        props: (route: Route) => ({
          uid: Number(route.query.uid),
          orderId: route.query.orderId,
        }),
        meta: {
          title: '交易成功',
        },
      },
      {
        path: '/market/chessClock', // 国象打卡
        name: 'Market.ChessClock',
        component: () => import(/* webpackChunkName: "market.chessclock" */ '../views/market/ChessClock/Index.vue'),
        meta: {
          title: '按时学习国象学费全返',
          query: QUERY,
        },
      },
      {
        path: '/market/chessClockExchange', // 国象打卡 - 兑换
        name: 'Market.ChessClockExchange',
        component: () => import(/* webpackChunkName: "market.chessclock.exchange" */ '../views/market/ChessClock/Exchange.vue'),
        meta: {
          title: '兑换课程',
          query: QUERY,
        },
        props: (route: Route) => ({
          goodsId: Number(route.query.goodsId),
          clockInVersion: Number(route.query.type),
          btnTitle: '兑换课程',
          groupTitle: '礼包兑换成功',
          groupSubtitle: '请在「已购内容」中查看课程',
        }),
      },
      {
        path: '/market/chessClockCashback', // 国象打卡 - 返现
        name: 'Market.ChessClockCashback',
        component: () => import(/* webpackChunkName: "market.chessclock.cashback" */ '../views/market/ChessClock/Cashback.vue'),
        meta: {
          title: '申请学费全返',
          query: QUERY,
        },
        props: (route: Route) => ({
          clockInVersion: Number(route.query.type),
        }),
      },
      {
        path: '/market/chessClockTaskReceive', // 国象打卡 - 领取任务2
        name: 'Market.ChessClockTaskReceive',
        component: () => import(/* webpackChunkName: "market.chessclock.receive" */ '../views/market/ChessClock/TaskReceive.vue'),
        meta: {
          title: '解锁任务二',
          query: QUERY,
        },
      },
    ],
  },
];
